export default {
  Ungrouped: [
      'cohort',
      'response',
      'sex',
      'age_group',
      'AJCC Stage',
      'stage_coding',
      'Biopsy_site_tissue',
      'Progression-free survival event',
      'Progression-free survival days',
      // 'FFPE Sample Type', 
      'Study_Site',
      'ICI_cluster'
      // 'Protein Subtype',
      // 'ethnicity'
    ],
  Mutation: [
    'TERT',
    'BRAF',
    'NRAS',
    'NF1',
    'ARID2'
  ],
  // Chromosome_gain: ["gain_chr7", "gain_chr17"],
  // Chromosome_loss: ["loss_chr1", "loss_chr3p", "loss_chr14q"],
  // Numerical: [],
};
